import styled from 'styled-components';
import { mq } from 'stylesheets/utils';

export const CommonSectionTitle = styled.h2`
  font-size: 3.4rem;
  color: ${({ theme }) => theme.colors.black};
  line-height: 1.2;
  text-align: center;
  margin-bottom: 24px;
  ${mq(768)} {
    font-size: 2.8rem;
  }
`;
export const CommonSectionSubTitle = styled.p`
  font-size: ${({ theme }) => theme.fontsizes.h6};
  font-weight: ${({ theme }) => theme.fontWeight.font700};
  color: ${({ theme }) => theme.colors.gray};
  text-align: center;
  width: 100%;
  margin-bottom: 24px;
`;
